/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const RetireMonitoringIntegrationHeaders = zod.object({
  'x-csrf-token': zod.string(),
  'Idempotency-Key': zod.string(),
});

export type RetireMonitoringIntegrationHeaders = zod.input<
  typeof RetireMonitoringIntegrationHeaders
>;
export type RetireMonitoringIntegrationHeadersOutput = zod.output<
  typeof RetireMonitoringIntegrationHeaders
>;
